// Frontend/src/components/admin/homescreens/EventsSection.jsx
import { FaCalendar } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import { useEvents } from "../../contexts/EventsContext";

const ACCESS_TOKEN = "EAAW2xrVlunoBOxH3OXOLqBTO5srLvspu61oWnSTchgIhprATMPp71lziGyEmMiLM6seDEQZBsaPAc6Rwmx46mwUkhwlwzUER8SqnVEJzCokkxUZCH9p1L2cEp1EUZBCR8ssQf2rbnbUWX6JyzMMcfZAv0o1h090ZCLZB2gTtiNo3rJfs5SnFnoEvRbDyCrTbxhZBX9wrCZAZBP4md3EjjHNmErrdmyVIbGO1ZAH4cvZCzWZB";
const PAGE_ID = "203411489522199";

const EventsSection = () => {
  const navigate = useNavigate();
  const { events } = useEvents();

  // Handle loading state
  if (!events) {
    return <div className="w-full bg-white rounded-lg shadow-lg p-4 mt-4 text-center">Loading Events...</div>;
  }

  const parseTimestamp = (timestamp) => {
    if (!timestamp) return new Date();
    if (timestamp._seconds && typeof timestamp._seconds === 'number') {
      const milliseconds = timestamp._seconds * 1000 + Math.floor(timestamp._nanoseconds / 1000000);
      return new Date(milliseconds);
    }
    return new Date(timestamp); // Fallback for string or Date object
  };

  const formatEventDate = (startDate, endDate, isSpanningEvent) => {
    if (!startDate) return "Date not specified";
    try {
      const start = parseTimestamp(startDate);
      if (isNaN(start.getTime())) {
        console.warn("Invalid start date:", startDate, "Falling back to default");
        return "Date not specified";
      }
      if (isSpanningEvent && endDate) {
        const end = parseTimestamp(endDate);
        if (isNaN(end.getTime())) {
          console.warn("Invalid end date:", endDate, "Using start date only");
          return Intl.DateTimeFormat('en-ZA', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'Africa/Johannesburg',
          }).format(start);
        }
        return `${Intl.DateTimeFormat('en-ZA', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          timeZone: 'Africa/Johannesburg',
        }).format(start)} - ${Intl.DateTimeFormat('en-ZA', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          timeZone: 'Africa/Johannesburg',
        }).format(end)}`;
      }
      return Intl.DateTimeFormat('en-ZA', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'Africa/Johannesburg',
      }).format(start);
    } catch (error) {
      console.error("Error formatting date:", error);
      return "Date not specified";
    }
  };

  return (
    <div className="w-full bg-white rounded-lg shadow-lg p-4 mt-4">
      <h2 className="text-xl font-bold text-black mb-1">Events</h2>
      <p className="text-sm text-primary font-bold mb-4">Don't miss our upcoming events</p>
      <ul className="w-full">
        {events.length > 0 ? (
          events.map((event, index) => (
            <li
              key={event.id}
              className={`w-full py-3 ${index < events.length - 1 ? "border-b border-gray-200" : ""}`}
              onClick={() => navigate(`/events/?category=events`)}
            >
              <div className="flex flex-col">
                <p className="font-medium text-dark">{event.title || "Untitled"}</p>
                <div className="flex items-center font-bold text-sm text-primary mt-1">
                  <FaCalendar className="mr-2" />
                  <span>{formatEventDate(event.startDate, event.endDate, event.isSpanningEvent)}</span>
                  {event.location && (
                    <span className="ml-2 text-xs bg-gray-100 px-2 py-1 rounded-full">
                      {event.location}
                    </span>
                  )}
                </div>
              </div>
            </li>
          ))
        ) : (
          <li className="w-full py-3 text-center text-gray-500">
            No upcoming events
          </li>
        )}
      </ul>
    </div>
  );
};

export default EventsSection;